<template>
    <div>
        <div>

            <b-container fluid>
                <b-row>
                  <b-col md="1" class="my-1">
                  </b-col>

                  <b-col md="5" class="my-1">
                    <b-form-group horizontal class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Tik om resultaten te filteren" />
                        <!--<b-input-group-append>-->
                          <b-btn :disabled="!filter" @click="filter = ''" variant="success">Wissen</b-btn>
                        <!--</b-input-group-append>-->
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  
                  <b-col md="5" class="my-1">
                    <b-form-group horizontal class="mb-0">
                      <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-group>
                  </b-col>

                  <b-col md="2" class="my-1">
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="6" class="my-1">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
                  </b-col>
                </b-row>

                <b-table v-show="!searching" show-empty 
                    :items="items"
                    :fields="fields" 
                    :current-page="currentPage"
                    :per-page="perPage" 
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"                    
                    >
                  <template slot="name" slot-scope="row">{{row.value.first}} {{row.value.last}}</template>
                  <template slot="isActive" slot-scope="row">{{row.value?'Yes :)':'No :('}}</template>
                  <template slot="actions" slot-scope="row">
                    <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-button size="sm" @click.stop="info(row.item, row.index, $event.target)" class="mr-1">
                      Info modal
                    </b-button>
                    <b-button size="sm" @click.stop="row.toggleDetails">
                      {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                    </b-button>
                  </template>
                  <template slot="row-details" slot-scope="row">
                    <b-card>
                      <ul>
                        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                      </ul>
                    </b-card>
                  </template>
                </b-table>


                <b-row v-show="!searching && items.length>0">
                  <b-col md="6" class="my-1">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
                  </b-col>
                </b-row>

            </b-container>
        </div>
    </div>
</template>


<script>

// reference: https://bootstrap-vue.js.org/docs/components/table

export default {

    name: 'data-table',

    // props are propagated and managed from parent components
    props: {
      'items': this.items, 
      'fields': this.fields, 
      'searching': this.searching, 
      'sortBy': this.sortBy, 
      'sortDesc': this.sortDesc
    },

    data() {
      return {
        currentPage: 1,
        perPage: 10,
        totalRows: this.items.length,
        pageOptions: [ 
          {text: 'Toon 5 rijen per pagina', value: 5}, 
          {text: 'Toon 10 rijen per pagina', value: 10}, 
          {text: 'Toon 20 rijen per pagina', value: 20},
          {text: 'Toon 50 rijen per pagina', value: 50},
          {text: 'Toon 100 rijen per pagina', value: 100} ],
        sortDirection: 'asc',
        filter: null,
        modalInfo: { title: '', content: '' }
      }
    },
    computed: {
      sortOptions(){
          return this.fields
          .filter(f => f.sortable)
          .map(f => {return {text: f.label, value: f.key} })
        }
    },
    methods: {
      info (item, index, button) {
        this.modalInfo.title = `Row index: ${index}`
        this.modalInfo.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
      resetModal () {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
      },
      onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }  
    }
 
}
</script>

<style>
#app {
  width: 95%;
  margin-top: 50px; 
}

.VuePagination {
  text-align: center;
}

.vue-title {
  text-align: center;
  margin-bottom: 10px;
}

.vue-pagination-ad {
  text-align: center;
}

.glyphicon.glyphicon-eye-open {
  width: 16px;
  display: block;
  margin: 0 auto;
}

th:nth-child(3) {
  text-align: center;
}

.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}

</style>


// WEBPACK FOOTER //
// src/components/DataTable.vue